// src/Hooks/useSearchConversion.js

import { useState } from 'react';
import {
  collection,
  query,
  where,
  getDocs,
  limit,
  doc,
  getDoc,
  writeBatch,
} from 'firebase/firestore';
import { db, auth } from '../Firebase/firebase';
import { v4 as uuidv4 } from 'uuid';

export const useSearchConversion = () => {
  const [isConverting, setIsConverting] = useState(false);

  const convertSearchToMarker = async (searchData) => {
    if (!searchData) return null;
    setIsConverting(true);

    try {
      const user = auth.currentUser;
      let canUpdate = false;

      if (user && user.email) {
        const emailKey = user.email.toLowerCase().trim();
        const permRef = doc(db, 'permittedUsers', emailKey);
        const permSnap = await getDoc(permRef);

        if (permSnap.exists()) {
          const permData = permSnap.data();
          canUpdate = permData.canUpdateMarkers === true;
        }
      }

      if (!canUpdate) {
        throw new Error('PERMISSION_DENIED');
      }

      const iconsRef = collection(db, 'markerIcons');
      const q = query(iconsRef, where('isDefault', '==', true), limit(1));
      const snapshot = await getDocs(q);

      let defaultIconID = null;
      let defaultCategoryID = null;
      let defaultIconURL = null;

      if (!snapshot.empty) {
        const iconDoc = snapshot.docs[0];
        const iconData = iconDoc.data();
        defaultIconID = iconDoc.id;
        defaultCategoryID = iconData.categoryId;
        defaultIconURL = iconData.url || iconData.icon || null;
      }

      const today = new Date();
      const dateString = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

      const newMarkerId = uuidv4();
      const newGroupId = uuidv4();

      const geometryData = {
        position: {
          lat: searchData.lat,
          lng: searchData.lng,
        },
        iconID: defaultIconID,
        markerGroupID: newGroupId,
      };

      const groupData = {
        categoryId: defaultCategoryID,
        date: dateString,
        iconID: defaultIconID,
        icon: defaultIconURL,
        isPrivate: false,
        visibility: 'PUBLIC',
        lastModified: new Date().toISOString(),
        address: (searchData.address || '').toUpperCase(),
        city: (searchData.city || '').toUpperCase(),
        country: (searchData.country || '').toUpperCase(),
        state: (searchData.state || '').toUpperCase(),
        zip: (searchData.zip || '').toUpperCase(),
        markerID: newMarkerId,
        polygonID: null,
        polylineID: null,
      };

      const batch = writeBatch(db);
      batch.set(doc(db, 'markers', newMarkerId), geometryData);
      batch.set(doc(db, 'markerGroups', newGroupId), groupData);
      await batch.commit();

      return {
        id: newMarkerId,
        type: 'marker',
        icon: defaultIconURL,
        ...geometryData,
        ...groupData,
      };
    } catch (error) {
      console.error('Error converting search to marker:', error);
      throw error;
    } finally {
      setIsConverting(false);
    }
  };

  return { convertSearchToMarker, isConverting };
};
